export enum StopFlagDirection {
	DEBIT = 'DEBIT',
	CREDIT = 'CREDIT'
}
